import {
  consumePendingLoginToast,
  consumePendingLogoutToast,
} from '~/utils/authRedirect'
import { useSourceToast } from '~/composables/ui/useSourceToast'

export default defineNuxtPlugin(() => {
  const { loggedIn } = useOidcAuth()
  const toast = useSourceToast()

  const LOGIN_TITLE = 'Connexion réussie'
  const LOGIN_DESC = 'Vous êtes connecté à Mon Orga.'
  const LOGOUT_TITLE = 'Déconnexion'
  const LOGOUT_DESC = 'Vous avez été déconnecté.'

  function scheduleToast(fn: () => void): void {
    queueMicrotask(fn)
  }

  watch(
    loggedIn,
    (isLoggedIn, wasLoggedIn) => {
      const wasLoggedInTrue = wasLoggedIn === true
      const isLoggedInTrue = isLoggedIn === true

      if (!isLoggedInTrue && consumePendingLogoutToast()) {
        scheduleToast(() => {
          toast.info(LOGOUT_TITLE, LOGOUT_DESC)
        })
        return
      }

      if (wasLoggedInTrue && !isLoggedInTrue) {
        scheduleToast(() => {
          toast.info(LOGOUT_TITLE, LOGOUT_DESC)
        })
        return
      }

      if (!isLoggedInTrue) {
        return
      }

      if (consumePendingLoginToast()) {
        scheduleToast(() => {
          toast.success(LOGIN_TITLE, LOGIN_DESC)
        })
        return
      }

      if (wasLoggedIn === false) {
        scheduleToast(() => {
          toast.success(LOGIN_TITLE, LOGIN_DESC)
        })
      }
    },
    { flush: 'post', immediate: true },
  )
})
